import React from "react";

export default function Footer({ invoice }) {
  return (
    <div className="paymentInvoice_footer">
      <a
        className="invoiceFooter_details"
        href={invoice.attributes.details_url}
      >
        View Details
      </a>
      <div className="invoiceFooter_total">
        <span>
          TOTAL <span className="amount">{invoice.attributes.total}</span>
        </span>
      </div>
    </div>
  );
}
